module.exports = __webpack_public_path__ + "static/media/PDF11.39314b99.pdf";